<template>
  <div class="home-shell">
    <v-navigation-drawer
      v-model="drawer"
      class="app-drawer"
      width="296"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="$vuetify.breakpoint.smAndDown"
      mobile-breakpoint="960"
    >
      <div class="app-drawer__profile">
        <div class="app-drawer__brand">
          <div class="app-drawer__brand-mark">{{ userInitials }}</div>
          <div class="app-drawer__brand-text">
            <span class="app-drawer__eyebrow">Genesys Supogen</span>
            <strong class="app-drawer__title">Painel Operacional</strong>
          </div>
        </div>

        <div class="app-drawer__user">
          <v-avatar size="54" class="app-drawer__avatar">
            <v-img :src="userAvatar"></v-img>
          </v-avatar>
          <div>
            <div class="app-drawer__name">{{ usuario.nome }}</div>
            <span class="app-drawer__email">{{ usuario.email }}</span>
          </div>
        </div>
      </div>

      <v-list nav dense class="app-drawer__menu">
        <v-list-item-group v-model="selectedItem" color="primary" mandatory>
          <v-list-item
            v-for="(item, i) in items_computed"
            :key="i"
            @click="routerPagina(item)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <div class="home-shell__body">
      <v-toolbar flat class="app-topbar">
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

        <div class="app-topbar__title">
          <strong>{{ currentSection }}</strong>
          <span>Workspace da genesys</span>
        </div>

        <v-spacer></v-spacer>

        <div class="app-topbar__tools">
          <div class="app-topbar__phones">
            <ConsultaFones></ConsultaFones>
          </div>
        </div>
      </v-toolbar>

      <div class="app-content">
        <router-view name="router2" />
      </div>
    </div>

    <ScrollTop :style="{ marginBottom: '60px', zIndex: '999999' }" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ScrollTop from "primevue/scrolltop";
import ConsultaFones from "../components/ConsultaFone.vue";

export default {
  components: { ScrollTop, ConsultaFones },
  name: "Home",
  data: () => ({
    drawer: true,
    value: 0,
    selectedItem: 0,
    items: [
      {
        text: "Atendimentos",
        icon: "mdi-folder",
        dest: "inicial",
        idx: 0,
        nivel: 7,
      },
      {
        text: "Clientes",
        icon: "mdi-account-multiple",
        dest: "cliente",
        idx: 1,
        nivel: 7,
      },
      {
        text: "Faturamento",
        icon: "mdi-cash-multiple",
        dest: "faturamento",
        idx: 2,
        nivel: 1,
      },
      {
        text: "Bloqueios",
        icon: "mdi-account-cancel-outline",
        dest: "bloqueados",
        idx: 3,
        nivel: 7,
      },
      {
        text: "Pedidos",
        icon: "mdi-list-status",
        dest: "pedidos",
        idx: 4,
        nivel: 7,
      },
      {
        text: "Avisos",
        icon: "mdi-bell-outline",
        dest: "avisos",
        idx: 5,
        nivel: 7,
      },
      {
        text: "Ajuda",
        icon: "mdi-lifebuoy",
        dest: "ajuda",
        idx: 6,
        nivel: 7,
      },
    ],
    usuario: {},
    busca_conhecimento: "",
  }),
  computed: {
    ...mapState("Usuarios", ["menu_idx"]),
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
    currentSection() {
      const current = this.items.find((item) => item.dest === this.$route.name);
      return current ? current.text : "Painel";
    },
    items_computed: function () {
      var vm = this;
      return this.items.filter(function (e) {
        return e.nivel >= vm.getUser.nivel ? e : null;
      });
    },
    userInitials() {
      if (!this.usuario.nome) return "GS";
      return this.usuario.nome
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((parte) => parte.charAt(0).toUpperCase())
        .join("");
    },
    userAvatar() {
      if (this.usuario.imgtec) {
        return "data:image/jpeg;base64," + this.usuario.imgtec;
      }
      return require("../assets/user_tecnico.png");
    },
  },
  watch: {
    selectedItem: function (val) {
      this.setMenu(val);
    },
  },
  mounted() {
    this.usuario = this.getUser;
    this.selectedItem = this.menu_idx;
    this.drawer = this.$vuetify.breakpoint.mdAndUp;
  },
  methods: {
    ...mapActions("Usuarios", ["populaUsuario", "setMenu"]),
    routerPagina(item) {
      this.setMenu(item.idx);
      this.$router.replace({ name: item.dest });

      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }
    },
  },
};
</script>

<style scoped>
.home-shell {
  min-height: 100vh;
}
</style>
